import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=5f1b7868&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=5f1b7868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1b7868",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f1b7868')) {
      api.createRecord('5f1b7868', component.options)
    } else {
      api.reload('5f1b7868', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=5f1b7868&scoped=true&", function () {
      api.rerender('5f1b7868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KnawlZAYic12/JS/comp/GuestBox.vue"
export default component.exports